import { Fragment, useEffect, useRef, useState } from 'react';
import Item from '../../../../components/Lists/Item';
import './TimeControls.css';
import { Tag } from '../../../../components/Tags/Tag';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import { useDropdownConfig } from '../../../../contexts/DropdownsContext';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { LABELS } from '../../../../globals/globals';
import Input from '../../../../components/Inputs/Input';
import { useDispatch, useSelector } from 'react-redux';
import { createControlDraft, fetchControls, selectIdxControls, selectTimeControls, selectTimeCtrlLoading } from '../../../../redux/features/configuration/parts/TimeControlsSlice';
import { TimeControl } from './TimeControl';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { TimeControl2 } from './TimeControl2';
import { Skeleton } from '@mui/material';

const mockTimeControls = [
  {
    id: 0,
    engineeringTask: "--",
    name: "--",
    schedule: "--",
    // Schedule: "",

  }
]

const mockOverrides = [{
  id: 0,
  hours: "1000",
  cycles: "500",
  days: "50"
}]

const TimeControlList = ({ part, setListRef }) => {
  const dispatch = useDispatch();
  const loading = useSelector(selectTimeCtrlLoading);
  useEffect(() => {
    dispatch(fetchControls({ page: 0, part }));
  }, [part])

  const timeControls = useSelector(selectTimeControls);
  const idxTimeControls = useSelector(selectIdxControls);

  return (
    <div className='list' ref={(ref)=>setListRef(ref)}>
      {/* {JSON.stringify(timeControls)} */}
      {loading ? <div className='skeleton-container'>
        <Skeleton width="100%" height="var(--item-min-height)"/>
        <Skeleton width="100%" height="var(--item-min-height)"/>
        <Skeleton width="100%" height="var(--item-min-height)"/>
      </div> :(timeControls?.length > 0 ? timeControls.map(item =>
        <TimeControl2 timeControl={idxTimeControls[item.id]} key={item.id} part={part} />
      ) : <i>No time controls configured yet</i>)}

    </div>
  )
}

export const TimeControls = ({ part }) => {
  const dispatch = useDispatch();
  const { successMsg, infoMsg, warningMsg } = useSnackBar();
  const listRef = useRef(null);

  const setListRef = (newRef) => {
    listRef.current = newRef;
  }

  const addNewTimeControl = () => {
    infoMsg("Creating Time Control", "Creating new time control draft");
    dispatch(createControlDraft({ part })).then(action => {
      if (action.payload) {
        successMsg("Time Control Created");
        let openEvent = new MouseEvent('click', {
          bubbles: false,
          cancelable: true,
          view: window
        })
        listRef.current?.querySelector('summary')?.dispatchEvent(openEvent);
      }
      else {
        warningMsg("Something went wrong", action.error.message);
      }
    }
    );
  }


  return (
    <div className='section time-controls-component'>
      <div className='section-header'>
        <h2>PN Time Controls</h2>
        <button  onClick={addNewTimeControl} className='outlined icon small-size'>
          <i className='icon-add-new'></i>
        </button>
        {/* <div className="search-bar-input">
        <input placeholder="Search Part" />
        <i className="icon-search"></i>
      </div> */}

      </div>
      <TimeControlList setListRef ={setListRef} part={part} />
    </div>
  )

}

// { "load": { "version": null, "id": 1, "partId": 18, "engineeringTaskId": 2, "overrides": [{ "version": null, "id": 1, "timeControlId": 1, "aircraftTypes": [{ "id": 1, "timeControlOverrideId": 1, "aircraftTypeId": 1 }, { "id": 2, "timeControlOverrideId": 1, "aircraftTypeId": 2 }], "aircrafts": [{ "id": 1, "timeControlOverrideId": 1, "aircraftId": 11 }, { "id": 2, "timeControlOverrideId": 1, "aircraftId": 15 }], "position": "test", "nhaId": 1, "nlaPosition": "test", "controls": [{ "id": 1, "timeControlOverrideId": 1, "controlUnitId": 1, "quantity": 2000.0 }, { "id": 2, "timeControlOverrideId": 1, "controlUnitId": 2, "quantity": 50.0 }, { "id": 3, "timeControlOverrideId": 1, "controlUnitId": 3, "quantity": 1000.0 }] }] }, "responseCode": 200, "message": "Request processed successfully", "validationErrors": null, "page": null, "pageSize": null, "totalPages": null, "totalRecords": null, "auxiliarInformation": null }